import services from '@/services'
const { malaDireta } = services

const state = {
  status: '',
  token: localStorage.getItem('token') || ''
}

const mutations = {
  'SET_AUTH_STATUS' (state, status = 'loading') {
    state.status = status
  },
  'SET_AUTH_STATUS_ERROR' (state, status = 'error') {
    state.status = status
  },
  'SET_AUTH_TOKEN' (state, token) {
    localStorage.setItem('token', token)
    state.token = token
  },
  'RESET_AUTH_TOKEN' (state) {
    state.token = ''
    localStorage.removeItem('token')
  }
}

const actions = {
  authenticateUser ({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      commit('SET_AUTH_STATUS', 'loading')
      malaDireta.auth.oauth(params)
      .then(res => {
          commit('SET_AUTH_STATUS', 'success')
          commit('SET_AUTH_TOKEN', 'a4568asasa_token') // fake no momento
          return res
        })
        .then(res => resolve(res))
        .catch(err => {
          commit('SET_AUTH_STATUS_ERROR', 'error')
          dispatch('logout', 'error')
          reject(err)
        })
    })
  },

  logout ({ commit }, status = '') {
    commit('SET_AUTH_STATUS', status)
    commit('RESET_AUTH_TOKEN')
  }
}

const getters = {
  isLoggedIn: state => !!state.token
}

export default {
  state,
  actions,
  mutations,
  getters
}
